// SS PWA — components/health/OutcomeCard.tsx — 2026-06-03
//
// CLIENT-FACING. Single big-number outcome card. Copy comes from
// healthOutcomeCopy.ts (locked). Never shows internal metrics.

import type { ReactNode } from 'react';

interface OutcomeCardProps {
  big: ReactNode;
  sub: string;
  emphasis?: 'default' | 'highlight';
}

export function OutcomeCard({ big, sub, emphasis = 'default' }: OutcomeCardProps) {
  const ring =
    emphasis === 'highlight'
      ? 'ring-1 ring-emerald-300 dark:ring-emerald-800'
      : '';
  return (
    <div className={`rounded-2xl border border-ink-200 bg-white p-4 dark:border-[#1F2A37] dark:bg-[#0F172A] ${ring}`}>
      <div className="text-2xl font-bold text-ink-900 tabular-nums dark:text-white">
        {big}
      </div>
      <div className="mt-1 text-sm text-ink-600 dark:text-[#94A3B8]">{sub}</div>
    </div>
  );
}
